var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7.1167,
    width: 11.0545,
    height: 0.727273,
    fill: "url(#paint0_linear_2930_1899)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.49091 2.90909L5.52727 0L7.56364 2.90909L11.0545 0V6.10909H0V0Z",
    fill: "url(#paint1_linear_2930_1899)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2930_1899",
    x1: 5.52727,
    y1: 7.1167,
    x2: 5.52727,
    y2: 7.84397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC42B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2930_1899",
    x1: 5.52727,
    y1: 0,
    x2: 5.52727,
    y2: 6.10909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC42B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA61B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrime);
export default __webpack_public_path__ + "static/media/prime.a2f2fdd2b81f23d59260268a9a6158e7.svg";
export { ForwardRef as ReactComponent };